let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("29uZk")).then(() => parcelRequire('3mJDw'));